import DefaultLayout from "@/layouts/DefaultLayout";
import VendorTypeForm from "kinnect-front/FacilityMaintenance/VendorTypes/VendorTypeForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { FacilityMaintenanceVendorType } from "kinnect-models";
import { KActionDialog } from "kinnect-general";

export default {
	name: "FacilityMaintenancePage",

	metaInfo() {
		const title = this.editing
			? "Facility Maintenance - View Vendor Category"
			: "Facility Maintenance - Add Vendor Category";

		return { title };
	},

	props: { idVendorType: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "facility_maintenance_vendor_types",
		deleteDialogOpen: false,
		vendorType: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idVendorType );
		},

		genDeleteDialog() {
			if ( this.editing && this.vendorType && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete vendor category" )}
					onConfirm={() => this.vendorType.delete()}
					redirect={[ "back", { name: "facilityMaintenanceVendorTypes" } ]}
					title="Delete Vendor Category"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the maintenance vendor category <strong>{this.vendorType.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this maintenance vendor category"
				};
			}
		}
	},

	methods: {
		async fetchVendorType() {
			if ( this.editing ) {
				this.vendorType = await FacilityMaintenanceVendorType.findPageModel( this.idVendorType );
			}
		},

		async fetch() {
			await this.fetchVendorType();
		}
	},

	render() {
		return <DefaultLayout>
			<VendorTypeForm
				loading={this.$wait.is( "find vendor category" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				vendorType={this.vendorType}
			></VendorTypeForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
